/* KP custom: dual promo banners slider (kp-dual-banners section) */
if (!customElements.get('kp-dual-banners')) {
  class KpDualBanners extends HTMLElement {
    connectedCallback() {
      this.initWhenReady();

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', event => {
          if (event.target.contains(this)) {
            this.destroy();
            this.initWhenReady();
          }
        });
      }
    }

    disconnectedCallback() {
      this.destroy();
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    initWhenReady() {
      if (window.Swiper) {
        this.init();
      } else {
        window.addEventListener('load', () => this.init(), { once: true });
      }
    }

    init() {
      if (this.swiper || !window.Swiper) return;

      const configEl = this.querySelector('[data-kp-duo-config]');
      const cfg = configEl ? JSON.parse(configEl.textContent) : {};
      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      const options = {
        slidesPerView: 1,
        spaceBetween: 12,
        rewind: true,
        grabCursor: true,
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: cfg.gap != null ? cfg.gap : 16
          }
        }
      };

      const paginationEl = this.querySelector('.kp-duo__pagination');
      if (paginationEl) {
        options.pagination = { el: paginationEl, clickable: true };
      }

      this.swiper = new Swiper(swiperEl, options);
    }
  }
  customElements.define('kp-dual-banners', KpDualBanners);
}
